import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import copy from "clipboard-copy";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "../../Style/CrmDashBoardTable.css";
import OutsideClickHandler from "react-outside-click-handler";
import DataTable from "react-data-table-component";
import { FaTasks, FaSearch, FaPlus, FaCopy, FaFileCsv, FaFileExcel, FaFilePdf, FaPrint, FaColumns, FaEye } from "react-icons/fa";

function Task({ tableData = [], onCreateClick }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(4);
  const [value, setValue] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  useEffect(() => {
    if (tableData?.length) {
      setItemsPerPage(4);
    }
  }, [tableData]);

  const handleSort = (columnName) => {
    const columnKey = {
      Subject: "subject",
      Status: "status",
      "Due Date": "duedate",
      Priority: "priority",
      Assigned: "assigned",
      Created: "createdBy",
    }[columnName];

    setSortColumn(columnKey);
    setSortDirection((prevDirection) =>
      prevDirection === "asc" ? "desc" : "asc"
    );
  };

  const columns = [
    {
      name: <strong>Subject</strong>,
      selector: (row) => row.subject || row.title || "-",
      sortable: true,
      cell: (row) => (
        <span
          className="font-weight-bold text-primary text-decoration-none"
          style={{ cursor: "pointer" }}
          onClick={() => navigate(`/task-details/${row.id || row.taskId}/0`)}
          title="Click to view task details"
        >
          {row.subject || row.title || "-"}
        </span>
      ),
    },
    {
      name: <strong>Status</strong>,
      selector: (row) => row.status || "-",
      sortable: true,
      cell: (row) => (
        <span
          style={{
            color: "#fff",
            backgroundColor:
              row.status === "Completed" || row.status === "Closed"
                ? "#28a745"
                : row.status === "InProgress"
                ? "#17a2b8"
                : "#ffc107",
            padding: "4px 8px",
            fontSize: "75%",
            fontWeight: "700",
            borderRadius: "0.25rem",
          }}
        >
          {row.status || "Open"}
        </span>
      ),
    },
    { name: <strong>Due Date</strong>, selector: (row) => row.duedate || row.dueDate || "-", sortable: true },
    { name: <strong>Priority</strong>, selector: (row) => row.priority || "-", sortable: true },
    { name: <strong>Assigned</strong>, selector: (row) => row.assigned || row.assignedto || "-", sortable: true },
    { name: <strong>Created</strong>, selector: (row) => row.createdBy || row.createdby || "-", sortable: true },
    {
      name: <strong>Action</strong>,
      cell: (row) => (
        <button
          type="button"
          className="btn btn-sm btn-outline-info d-inline-flex align-items-center gap-1 py-0 px-2"
          style={{ fontSize: "0.75rem", borderRadius: "4px" }}
          onClick={() => navigate(`/task-details/${row.id || row.taskId}/0`)}
          title="View Task Details"
        >
          <FaEye size={12} /> View
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const extractNumber = (text) => {
    const match = String(text).match(/\d+/);
    return match ? parseInt(match[0], 10) : 0;
  };

  const filteredData = (tableData || [])
    .filter((ele) =>
      value === ""
        ? true
        : Object.values(ele).some((val) =>
            val?.toString().toLowerCase().includes(value.toLowerCase())
          )
    )
    .sort((a, b) => {
      if (!sortColumn) return 0;
      let aValue = a?.[sortColumn]?.toString().toLowerCase() || "";
      let bValue = b?.[sortColumn]?.toString().toLowerCase() || "";

      if (sortColumn === "subject") {
        aValue = extractNumber(aValue);
        bValue = extractNumber(bValue);
      }
      return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
    });

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const paginatedData = filteredData.slice(startIndex, endIndex);

  const [copied, setCopied] = useState(false);

  const handleCopyClick = () => {
    const formattedData = JSON.stringify(tableData, null, 2);
    copy(formattedData);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const convertToJson = () => {
    const csv = Papa.unparse(tableData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `task_data.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const convertToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `task_data.xlsx`);
  };

  const convertToPdf = () => {
    const doc = new jsPDF();
    const jsonString = JSON.stringify(tableData, null, 2);
    doc.text(jsonString, 10, 10);
    doc.save(`task_data.pdf`);
  };

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
        <html>
        <head><title>Print Tasks</title></head>
        <body><pre>${JSON.stringify(tableData, null, 2)}</pre></body>
        </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  const [visibile, setVisible] = useState(false);
  const handleDrop = () => setVisible(!visibile);
  const [Id, setId] = useState(true);
  const [Subject, setSubject] = useState(true);
  const [Status, setStatus] = useState(true);
  const [Duedate, setDuedate] = useState(true);
  const [Assigned, setAssigned] = useState(true);
  const [Priority, setPriority] = useState(true);
  const [Created, setCreated] = useState(true);

  return (
    <>
      {/* ── Toolbar + Search row ── */}
      <div
        className="d-flex justify-content-between align-items-center flex-wrap px-3 pt-3 pb-2"
        style={{ gap: "10px" }}
      >
        {/* Export buttons */}
        <div className="d-flex flex-wrap" style={{ gap: "6px" }}>
          <button
            className="btn btn-outline-secondary btn-sm"
            style={{
              fontSize: "0.8rem",
              fontWeight: 500,
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
            }}
            onClick={handleCopyClick}
            title="Copy data"
          >
            <FaCopy />
            {copied ? "Copied!" : "Copy"}
          </button>
          <button
            className="btn btn-outline-secondary btn-sm"
            style={{
              fontSize: "0.8rem",
              fontWeight: 500,
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
            }}
            onClick={convertToJson}
            title="Export CSV"
          >
            <FaFileCsv style={{ color: "#2e7d32" }} />
            CSV
          </button>
          <button
            className="btn btn-outline-secondary btn-sm"
            style={{
              fontSize: "0.8rem",
              fontWeight: 500,
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
            }}
            onClick={convertToExcel}
            title="Export Excel"
          >
            <FaFileExcel style={{ color: "#1565c0" }} />
            Excel
          </button>
          <button
            className="btn btn-outline-secondary btn-sm"
            style={{
              fontSize: "0.8rem",
              fontWeight: 500,
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
            }}
            onClick={convertToPdf}
            title="Export PDF"
          >
            <FaFilePdf style={{ color: "#c62828" }} />
            PDF
          </button>
          <button
            className="btn btn-outline-secondary btn-sm"
            style={{
              fontSize: "0.8rem",
              fontWeight: 500,
              whiteSpace: "nowrap",
              display: "inline-flex",
              alignItems: "center",
              gap: "5px",
            }}
            onClick={handlePrint}
            title="Print"
          >
            <FaPrint />
            Print
          </button>
          <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
            <div className="dropdown position-relative">
              <button
                className="btn btn-outline-secondary btn-sm dropdown-toggle"
                style={{
                  fontSize: "0.8rem",
                  fontWeight: 500,
                  whiteSpace: "nowrap",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "5px",
                }}
                onClick={handleDrop}
              >
                <FaColumns />
                Columns
              </button>
              <div
                className={`dropdown-menu ${visibile ? "show" : ""} p-2`}
                style={{ minWidth: "160px", right: 0 }}
              >
                {[
                  { label: "ID", state: Id, toggle: () => setId(!Id) },
                  { label: "Subject", state: Subject, toggle: () => setSubject(!Subject) },
                  { label: "Status", state: Status, toggle: () => setStatus(!Status) },
                  { label: "Due Date", state: Duedate, toggle: () => setDuedate(!Duedate) },
                  { label: "Priority", state: Priority, toggle: () => setPriority(!Priority) },
                  { label: "Assigned", state: Assigned, toggle: () => setAssigned(!Assigned) },
                  { label: "Created", state: Created, toggle: () => setCreated(!Created) },
                ].map((item, idx) => (
                  <div
                    key={idx}
                    className="dropdown-item rounded my-1 text-center py-1"
                    onClick={item.toggle}
                    style={{
                      backgroundColor: item.state ? "#f59e0b" : "#e9ecef",
                      color: item.state ? "#fff" : "#333",
                      fontSize: "0.82rem",
                      cursor: "pointer",
                    }}
                  >
                    {item.label}
                  </div>
                ))}
              </div>
            </div>
          </OutsideClickHandler>
        </div>

        {/* Search box */}
        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
          <span className="text-muted" style={{ fontSize: "0.85rem", fontWeight: 500 }}>
            Search:
          </span>
          <div className="input-group" style={{ width: "280px", flexWrap: "nowrap" }}>
            <span
              className="input-group-text"
              style={{
                background: "#f8f9fa",
                border: "1px solid #dee2e6",
                borderRight: "none",
                borderRadius: "8px 0 0 8px",
                padding: "0 10px",
              }}
            >
              <FaSearch className="text-secondary" style={{ fontSize: "0.8rem" }} />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Search tasks..."
              onChange={(e) => setValue(e.target.value)}
              value={value}
              style={{
                border: "1px solid #dee2e6",
                borderLeft: "none",
                borderRadius: "0 8px 8px 0",
                fontSize: "0.875rem",
                height: "34px",
                transition: "box-shadow 0.2s",
              }}
              onFocus={(e) => {
                e.target.style.boxShadow = "0 0 0 3px rgba(245,158,11,0.15)";
                e.target.style.outline = "none";
              }}
              onBlur={(e) => {
                e.target.style.boxShadow = "none";
              }}
            />
          </div>
        </div>
      </div>

      {filteredData.length === 0 ? (
        <div className="text-center py-5 bg-light rounded border">
          <FaTasks style={{ fontSize: "3rem", color: "#6c757d", marginBottom: "1rem" }} />
          <h5 className="text-secondary">No Tasks Found</h5>
          <p className="text-muted mb-3">There are no tasks logged for this record yet.</p>
          {onCreateClick && (
            <button className="btn btn-primary btn-sm px-3 rounded-pill" onClick={onCreateClick}>
              <FaPlus className="mr-1" /> Create Task
            </button>
          )}
        </div>
      ) : (
        <div className="table-container border rounded">
          <DataTable
            columns={columns}
            data={paginatedData}
            pagination
            paginationServer
            paginationTotalRows={filteredData.length}
            onChangePage={setCurrentPage}
            onChangeRowsPerPage={(newPerPage) => {
              setItemsPerPage(newPerPage);
              setCurrentPage(1);
            }}
            sortServer
            onSort={(column) => handleSort(column.name)}
            highlightOnHover
            striped
          />
        </div>
      )}
    </>
  );
}

export default Task;